import {
  LINE_CONTACT_BOT1,
  LINE_CONTACT_BOT2,
  LINE_ID_BOT1,
  LINE_ID_BOT2,
} from '../config/env'

export function getLineContact(botId?: string) {
  if (botId === '2') {
    return { href: LINE_CONTACT_BOT2, label: LINE_ID_BOT2 }
  }
  return { href: LINE_CONTACT_BOT1, label: LINE_ID_BOT1 }
}
